import { Header } from "@/components/layout/Header";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";
import { LevelManager } from "@/components/admin/LevelManager";
import { ClassStreamManager } from "@/components/admin/ClassStreamManager";
import { ClassPromotionManager } from "@/components/nurse/ClassPromotionManager";

export default function ClassesAndStreams() {
  const [isLevelOpen, setIsLevelOpen] = useState(false);
  const [isClassStreamOpen, setIsClassStreamOpen] = useState(false);
  const [isPromotionOpen, setIsPromotionOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container px-4 py-6 mt-[147px] space-y-6">
        <h1 className="text-2xl font-bold">Classes and Streams Management</h1>

        <div className="space-y-4">
          <Collapsible open={isLevelOpen} onOpenChange={setIsLevelOpen}>
            <Card>
              <CardHeader className="cursor-pointer" onClick={() => setIsLevelOpen(!isLevelOpen)}>
                <CollapsibleTrigger className="flex items-center justify-between w-full">
                  <CardTitle>Level Management</CardTitle>
                  {isLevelOpen ? <ChevronDown className="h-5 w-5" /> : <ChevronRight className="h-5 w-5" />}
                </CollapsibleTrigger>
              </CardHeader>
              <CollapsibleContent>
                <CardContent>
                  <LevelManager />
                </CardContent>
              </CollapsibleContent>
            </Card>
          </Collapsible>

          <Collapsible open={isClassStreamOpen} onOpenChange={setIsClassStreamOpen}>
            <Card>
              <CardHeader className="cursor-pointer" onClick={() => setIsClassStreamOpen(!isClassStreamOpen)}>
                <CollapsibleTrigger className="flex items-center justify-between w-full">
                  <CardTitle>Classes & Streams Management</CardTitle>
                  {isClassStreamOpen ? <ChevronDown className="h-5 w-5" /> : <ChevronRight className="h-5 w-5" />}
                </CollapsibleTrigger>
              </CardHeader>
              <CollapsibleContent>
                <CardContent>
                  <ClassStreamManager />
                </CardContent>
              </CollapsibleContent>
            </Card>
          </Collapsible>

          <Collapsible open={isPromotionOpen} onOpenChange={setIsPromotionOpen}>
            <Card>
              <CardHeader className="cursor-pointer" onClick={() => setIsPromotionOpen(!isPromotionOpen)}>
                <CollapsibleTrigger className="flex items-center justify-between w-full">
                  <CardTitle>Student Promotion</CardTitle>
                  {isPromotionOpen ? <ChevronDown className="h-5 w-5" /> : <ChevronRight className="h-5 w-5" />}
                </CollapsibleTrigger>
              </CardHeader>
              <CollapsibleContent>
                <CardContent>
                  <div className="space-y-4">
                    <p className="text-sm text-muted-foreground">
                      Promote students to their next classes based on the configured class progression paths.
                      Make sure all classes have their next class set correctly before proceeding with promotion.
                    </p>
                    <ClassPromotionManager />
                  </div>
                </CardContent>
              </CollapsibleContent>
            </Card>
          </Collapsible>
        </div>
      </main>
    </div>
  );
}